import { useState, useRef, useEffect } from "react";
import { useGetStripeAccountLinkQuery } from "../../api/api";

const PayoutWarning = ({ vendorId }: { vendorId: number }) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const tooltipRef = useRef<HTMLDivElement | null>(null);

  const { isLoading, data } = useGetStripeAccountLinkQuery({ vendorId });

  // Hide tooltip when clicking/tapping outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target as Node)
      ) {
        setIsTooltipVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative inline-block">
      {/* Warning Button */}
      <button
        type="button"
        className="text-sm font-normal bg-yellow-400 text-white border px-4 py-2 rounded-lg"
        onMouseEnter={() => setIsTooltipVisible(true)} // Show on hover (desktop)
        onClick={() => setIsTooltipVisible(true)} // Show on click (mobile & desktop)
      >
        ⚠️ Payout Warning
      </button>

      {/* Tooltip */}
      {isTooltipVisible && (
        <div
          ref={tooltipRef}
          className="absolute left-1/2 transform -translate-x-1/2 mt-2 w-64 p-3 bg-red-600 text-white text-sm rounded-lg shadow-lg z-10"
        >
          <p className="font-medium">
            Your account is not eligible for payouts.
          </p>
          <p className="text-xs mt-1">
            Complete verification to enable payouts.
          </p>
          <button
            type="button"
            className="mt-2 bg-white text-red-600 font-medium px-3 py-1 rounded-lg hover:bg-gray-100 transition"
            onClick={() => {
              if (data?.data.url) {
                window.open(data.data.url, "_self"); // Open in same tab
              }
            }}
          >
            Complete Verification
          </button>
        </div>
      )}
    </div>
  );
};

export default PayoutWarning;
